import { PATHS } from '@/shared/config';

import { TabValue } from '../config/constants';

export type AnalyticsEditorMode = 'new' | 'edit';

export type BuildAnalyticsUrlParams = {
  id?: string;
  mode?: AnalyticsEditorMode;
};

export const ANALYTICS_TAB_PATH = `${PATHS.companySettings}?tab=${TabValue.Analytics}`;

export const buildAnalyticsUrl = (
  params: BuildAnalyticsUrlParams = {},
): string => {
  const search = new URLSearchParams({ tab: TabValue.Analytics });

  if (params.mode) {
    search.set('mode', params.mode);
  }

  if (params.id) {
    search.set('id', params.id);
  }

  return `${PATHS.companySettings}?${search.toString()}`;
};
